export const QUERY_KEYS = {
  AUTH: {
    GET_ME: ['getme'],
    LOCKOUT_STATUS: ['lockout-status'],
  },
} as const
